import _ from 'lodash';
import gatewayFetch from '../../appModules/utilities/gatewayFetch';

/**
 * Seeds the functions that fetch information from graphQL
 * @param  {function}   template  lodash template function for grahQL request
 * @param  {string}     queryType type of graphQL call 'mutation' or 'query'
 * @param  {function}   request action creator that initiates the request
 * @param  {function}   success action creator that creates the success action
 * @param  {function}   failure action creator that creates the failure action
 * @return {function}   the function to make the call to graphQL
 */
export default function seedHelperFn(
  template,
  queryType,
  request,
  success,
  failure
) {
  return templateParams => dispatch => {
    dispatch(request());

    const resolver = {
      fetch() {
        return gatewayFetch(template(templateParams), queryType)
          .then(data => dispatch(success(data)))
          .catch(reason => dispatch(failure(reason)));
      },
      abort() {
        return Promise.resolve(
          dispatch(failure('no template parameters present'))
        );
      },
    };

    return resolver[_.isEmpty(templateParams) ? 'abort' : 'fetch']();
  };
}



// WEBPACK FOOTER //
// ./src/reactModules/redux/seedHelperFn.js